import DashboardNavigationBar from '@/components/dashboard/navigation-bar/dashboard-navigation-bar';
import Loading from '@/components/loading/loading';
import useActionPlanController from './action-plan.controller';
import ActionPlanHeader from './components/action-plan-header';
import ActionPlanDashboard from './components/dashboard/dashboard';
import EmptyState from './components/empty-state/empty-state';
import ModalIntroWizard from './components/modal-intro-wizard/modal-intro-wizard';

export default function ActionPlanPage() {
  const {
    name,
    interventions,
    potentialRiskDecrease,
    isLoading,
    handleCompleteIntervention,
    allInterventionsCompleted,
    modalIntroWizardDisclosure,
    handleFinishIntroWizard,
  } = useActionPlanController();

  if (isLoading) {
    return <Loading />;
  }

  return (
    <>
      <DashboardNavigationBar activeItem="action-plan" />
      <ActionPlanHeader
        hasPlan={!!interventions?.length}
        potentialRiskDecrease={potentialRiskDecrease}
        allInterventionsCompleted={allInterventionsCompleted}
      />
      {interventions?.length ? (
        <ActionPlanDashboard interventions={interventions} onCompleteIntervention={handleCompleteIntervention} />
      ) : (
        <EmptyState name={name} />
      )}

      <ModalIntroWizard
        isOpen={modalIntroWizardDisclosure.isOpen}
        onClose={modalIntroWizardDisclosure.onClose}
        onFinish={handleFinishIntroWizard}
      />
    </>
  );
}
